import * as Localization from "expo-localization";

/** The device's ISO country code, or null when the platform has none. */
export function getDeviceCountryCode(): string | null {
  try {
    return Localization.getLocales()[0]?.regionCode?.toUpperCase() ?? null;
  } catch {
    return null;
  }
}
